import { render, staticRenderFns } from "./productionAsins.vue?vue&type=template&id=5a8048ec&scoped=true"
import script from "./productionAsins.vue?vue&type=script&lang=js"
export * from "./productionAsins.vue?vue&type=script&lang=js"
import style0 from "./productionAsins.vue?vue&type=style&index=0&id=5a8048ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8048ec",
  null
  
)

export default component.exports